import type { EstimatedSummary, MoneySummary } from "@/types/spend";

export const formatGbp = (value: string | null) => {
  if (value === null) return null;
  const match = /^(-?)(\d+)(?:\.(\d+))?$/.exec(value);
  if (!match) return value;
  const [, sign, integer, fraction = ""] = match;
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${sign}£${grouped}.${fraction.padEnd(2, "0").slice(0, 2)}`;
};

export const moneyAmountDisplay = (money: MoneySummary) => {
  if (!money.has_data || money.net_gbp === null) return "No Available Spend";
  return formatGbp(money.net_gbp) ?? "No Available Spend";
};

export const moneyDisplay = (money: MoneySummary) => {
  const value = moneyAmountDisplay(money);
  return money.has_data && money.net_gbp !== null && !money.complete ? `${value} · Incomplete spend` : value;
};

export const estimateDisplay = (estimate: EstimatedSummary) => {
  if (estimate.amount_gbp === null) return "Not available";
  const value = formatGbp(estimate.amount_gbp) ?? "Not available";
  return estimate.complete ? value : `${value} · Incomplete estimate`;
};
